module.exports = __webpack_public_path__ + "img/01.4f60ff4b.jpg";